var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"card"},[_c('h3',[_vm._v("Расписание")]),_c('Timetable',{attrs:{"data":_vm.data.booking.timetable},on:{"update:data":function($event){return _vm.$set(_vm.data.booking, "timetable", $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }